/** A save the API refused for a reason no single field owns: permission, a missing record, an outage. */
import { AlertTriangle } from 'lucide-react';

export function EditorSaveProblem({ message }: { message: string }) {
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '10px 14px',
        borderRadius: 10,
        fontSize: 13,
        fontWeight: 600,
        color: 'var(--nb-warn)',
        background: 'var(--nb-warn-soft)',
      }}
    >
      <AlertTriangle size={16} aria-hidden style={{ flex: '0 0 auto' }} />
      {message}
    </div>
  );
}
